import type Konva from "konva";
import React from "react";

import { ContainerContextProvider, type ContainerContextValue, useSize } from "./_container-context";
import { Node, type NodeConfig } from "./Node";

export type ContainerConfig = NodeConfig;

export interface ContainerProps extends ContainerConfig {
	instance: Konva.Container;
}

export const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({ instance, children, ...config }) => {
	const size = useSize(config);

	const context = React.useMemo<ContainerContextValue>(() => ({ instance, size }), [instance, size]);

	React.useLayoutEffect(
		() => () => {
			instance.removeChildren();
		},
		[instance],
	);

	return (
		<Node instance={instance} {...config}>
			<ContainerContextProvider value={context}>{children}</ContainerContextProvider>
		</Node>
	);
};
